import { Component, OnInit } from '@angular/core';
import { AgilityRiskService } from '../../../../../providers/agility-risk.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AnswerTemplate, RiskDetail } from '../../../../../models/risk-detail';
import { AssessmentMemberData } from '../../../../../models/assessment-member-data';
import { QuestionType } from '../../../../../models/question-type';
import * as _ from 'lodash';
import { AssessmentMemberAnswer } from '../../../../../models/assessment-member-answer';
import { AssessmentFactorSelection } from '../../../../../models/assessment-factor-selection';
import { RiskFactorRank } from '../../../../../models/risk-factor-rank';
import { AgilityRiskMessageService } from '../../../../../providers/agility-risk-message.service';

@Component({
  selector: 'lib-risk-assessment-risk-member-answers-modal',
  templateUrl: './risk-assessment-risk-member-answers-modal.component.html',
  styleUrls: ['./risk-assessment-risk-member-answers-modal.component.scss']
})
export class RiskAssessmentRiskMemberAnswersModalComponent implements OnInit {
  // NOTE: DON'T LIKE THIS, BUT ALL SAVING HAPPENS IN MODAL. MODAL IS SMARTER THAN IT NEEDS TO BE.
  public riskDetail: RiskDetail;
  public answerTemplate: AnswerTemplate;
  public assessmentMemberData: AssessmentMemberData[] = [];
  public assessmentMemberDataOriginal: AssessmentMemberData[] = [];
  public questionType = QuestionType;
  public booleanSelectOptions = [
    {
      label: this.translateService.instant('common.yes'),
      value: this.translateService.instant('common.yes').toUpperCase()
    },
    {
      label: this.translateService.instant('common.no'),
      value: this.translateService.instant('common.no').toUpperCase()
    },
    {
      label: this.translateService.instant('common.na'),
      value: 'NA'
    }
  ];
  public minimumRank = 1; // always 1 per PO instructions;
  public loading = true;
  public canEdit: boolean = false;

  constructor(private agilityRiskService: AgilityRiskService,
              private translateService: TranslateService,
              public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig,
              private messageService: AgilityRiskMessageService) {
    this.answerTemplate = this.dynamicDialogConfig?.data?.answerTemplate;
    this.riskDetail = this.dynamicDialogConfig?.data?.riskDetail;
    this.canEdit = this.dynamicDialogConfig?.data?.canEdit === true;
  }

  ngOnInit(): void {
    this.getRiskAssessmentRiskAnswers();
  }


  getRiskAssessmentRiskAnswers() {
    this.agilityRiskService.getRiskAssessmentRiskAnswers(this.riskDetail.id)
      .subscribe(
        (assessmentMemberData: AssessmentMemberData[]) => {
          this.assessmentMemberData = assessmentMemberData;

          this.assessmentMemberData.forEach((amd: AssessmentMemberData) => {
            amd.memberAnswers.forEach((ma: AssessmentMemberAnswer) => {
              ma.factors.forEach((f: AssessmentFactorSelection) => {
                // init so UI doesn't blow up
                /// just precautionary safety code
                if (!f?.factor || !f?.factor?.id) {
                  f.factor = new RiskFactorRank();
                  // default it to the 1st one
                  f.factor.id = f.type.ranks[0].id;
                  f.factor.numericValue = f.type.ranks[0].numericValue;
                } else {
                  f.factor.numericValue = f.type.ranks.find((rfr: RiskFactorRank) => rfr.id === f.factor.id)?.numericValue || 0;
                }
              });
            });
          });

          // then keep a clone for cancelling edit
          this.assessmentMemberDataOriginal = _.cloneDeep(assessmentMemberData);
          this.loading = false;
        },
        err => {
          this.messageService.error(this.translateService.instant('common.error'));
          this.close();
        });
  }

  cancelChanges(memberAnswer: AssessmentMemberAnswer, assessmentMemberDataIndex: number): void {
    // find the original and put it back
    const original: AssessmentMemberAnswer = this.assessmentMemberDataOriginal[assessmentMemberDataIndex].memberAnswers.find((ma: AssessmentMemberAnswer) => ma.id === memberAnswer.id);
    memberAnswer.questionAnswer = original.questionAnswer;
    memberAnswer.factors = original.factors;
    memberAnswer.comments = original.comments;
    memberAnswer.isEditing = false;
  }

  saveChanges(memberAnswer: AssessmentMemberAnswer): void {
    this.agilityRiskService.putRiskAssessmentAnswer(memberAnswer)
      .subscribe(
        () => {
          memberAnswer.isEditing = false;
          this.getRiskAssessmentRiskAnswers();
          this.messageService.success(this.translateService.instant('common.saved'));
        },
        err => {
          this.messageService.error(this.translateService.instant('common.error'));
        }
      );
  }

  setFactorTypeId(assessmentFactorSelection: AssessmentFactorSelection): void {
    // find the id of the set rank and set the id for saving
    assessmentFactorSelection.factor.id = assessmentFactorSelection.type.ranks.find((r: RiskFactorRank) => r.numericValue === assessmentFactorSelection.factor.numericValue)?.id || null;
  }

  close(): void {
    this.dynamicDialogRef.close(false);
  }

  getMax(assessmentFactorSelection: AssessmentFactorSelection): number {
    return (assessmentFactorSelection.type.ranks.length) - (assessmentFactorSelection.type.ranks.find((r: RiskFactorRank) => r.numericValue === 0) ? 1 : 0);
  }
}
